import { render } from "./RibaOrderDetail.vue?vue&type=template&id=9abe3ebc"
import script from "./RibaOrderDetail.vue?vue&type=script&lang=js"
export * from "./RibaOrderDetail.vue?vue&type=script&lang=js"
script.render = render

export default script